
import {
    ConditionOptionsBase,
    ConditionTypeEnum,
    ShowHideConditionOptions,
    ValidationConditionOptions
} from "./ConditionOptions";
import {StoreBase, StoreDataType} from "shared/core/Store/StoreBase";

export enum FieldTypeEnum {
    Text='text',
    TextArea='textarea',
    Radio='radio',
    Checkbox='checkbox',
    DropDown='dropdown',
    Hidden='hidden',
    Paragraph='paragraph',
    FileUpload='fileupload',
    ImagePicker='imagepicker',
    Divider='divider',
    Repeater='repeater',
    List='list',
    GroupPanel='grouppanel',
    RepeaterItem='repeater_item',
    Datepicker='datepicker',
    DateRange='daterange',
    Masked='masked',
    ColorPicker='colorpicker',
    Slider='slider',
    ButtonSelection='buttonselection',
    Switch='switch',
    Signature='signature',
    ColorSwatcher='colorswatcher',
    TermOfService='termofservice',
    GoogleMaps='googlemaps',
    TextualImage='textualimage'
}

export enum PreferredReturnType{
    String='string',
    Price='price'
}

export class FormulaOptions extends StoreBase{
    public Code:string;
    public Name:string;
    @StoreDataType(Number)
    public Fields:number[];
    public PreferredReturnType:PreferredReturnType;

    @StoreDataType(Object)
    public Compiled:any;

    protected LoadDefaultValues() {
        this.Code='';
        this.Name='';
        this.Compiled=null;
        this.PreferredReturnType=PreferredReturnType.Price;
        this.Fields=[];
    }
}

export class FBFieldBaseOptions extends StoreBase{
    Id:number;
    Type:FieldTypeEnum;
    Label:string;
    Required:boolean;
    RowId:number;
    @StoreDataType(ConditionOptionsBase)
    Conditions:ConditionOptionsBase[];
    public IsFieldContainer:boolean;

    @StoreDataType(FormulaOptions)
    public Formulas:FormulaOptions[];
    public Description='';
    public Tooltip='';
    protected LoadDefaultValues() {
        this.Type=FieldTypeEnum.Text;
        this.Label='';
        this.Id=0;
        this.Required=false;
        this.RowId=0;
        this.Conditions=[];
        this.Formulas=[];
        this.Description='';
        this.Tooltip='';
    }


    protected GetValueFromLoader(property:any, value: any): any {
        if(property=="Conditions")
        {
            if(value==null)
                return [];

            let valuesToReturn=[];
            for(let currentValue of value as ConditionOptionsBase[])
            {
                switch (currentValue.Type) {
                    case ConditionTypeEnum.ShowHide:
                        valuesToReturn.push(
                            new ShowHideConditionOptions().Merge(currentValue)
                        );
                        break;

                    case ConditionTypeEnum.Validation:
                        valuesToReturn.push(
                            new ValidationConditionOptions().Merge(currentValue)
                        );
                        break;
                }
            }

            return valuesToReturn;
        }
    }
}

